var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#E5E5E5","d":"M8,19H5V9h3V19z M19,19h-3v-5.342c0-1.392-0.496-2.085-1.479-2.085c-0.779,0-1.273,0.388-1.521,1.165C13,14,13,19,13,19h-3   c0,0,0.04-9,0-10h2.368l0.183,2h0.062c0.615-1,1.598-1.678,2.946-1.678c1.025,0,1.854,0.285,2.487,1.001   C18.683,11.04,19,12.002,19,13.353V19z"})),React.createElement("g",{"key":1},React.createElement("ellipse",{"fill":"#E5E5E5","cx":"6.5","cy":"6.5","rx":"1.55","ry":"1.5"}))]);
}

Linkedin.defaultProps = {"baseProfile":"tiny","height":"24px","id":"Layer_1","version":"1.2","viewBox":"0 0 24 24","width":"24px","xmlSpace":"preserve"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
